import axios from "./axios";

export default {
  namespaced: true,

  state: {
    editPatient: [],
    editName: [],
    languages: [],
    religion: [],
    editAddress: [],
    privacy: [],
    patient: [],
    person: [],
  },
  getters: {
    gLanguages(state) {
      return state.languages;
    },
    gReligion(state) {
      return state.religion;
    },
    gMe(state) {
      return state.editPatient;
    },
    gAddress(state) {
      return state.editAddress;
    },
    gPrivacy(state) {
      return state.privacy;
    },
    gEditName(state) {
      return state.editName;
    },
    gPatient(state) {
      return state.patient;
    },
  },
  actions: {
    aPersonal({ rootGetters, commit, rootState }) {
      //console.log(rootGetters.userauth.gLoggedIn)
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.get('profile/personal/edit/' + rootGetters['user/gCurrentProfile'])
            .then(response => {
              if (response.data.status) {

                commit('mPersonal', response.data.data.details);
                commit('mLanguages', response.data.data.langauges);
                commit('mReligion', response.data.data.religion);
                commit('mPrivacy', response.data.data.privacy);
                commit('mAddress', response.data.data.address);
                //commit('SetName', response.data.data.names)
                resolve(true);
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    aPersonalDetails({ rootGetters, commit, rootState }) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.get('profile/personal/' + rootGetters['user/gCurrentProfile'])
            .then(response => {
              if (response.data.status) {
                //console.log(response.data.data);
                commit('mPersonal', response.data.data.details);
                commit('mLanguages', response.data.data.languages);
                commit('mReligion', response.data.data.religions);
                commit('mPrivacy', response.data.data.privacy);
                commit('mAddress', response.data.data.address);
                //commit('SetName', response.data.data.names)
                resolve(true);
              }
            })
            .catch(error => {
              reject(error);
            })
        })
      }
    },
    aUpdatePerson({ rootGetters, commit, rootState }, person) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.put('profile/personal/' + rootGetters['user/gCurrentProfile'], JSON.stringify(person))
            .then(response => {
              if (response.data.status) {
                //commit('mUpdatePerson', response.data);
                commit('mPersonal', response.data.data.details);
                //commit('mLanguages', response.data.data.languages);
                //commit('mReligion', response.data.data.religions);
                commit('mPrivacy', response.data.data.privacy);
                commit('mAddress', response.data.data.address);
                resolve(true);
              }
            })
            .catch(error => {
              reject(error);
            })
        })
      }
    },
    aUpdatePrivacy({ rootGetters, commit, rootState}, privacy) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.put('profile/personal/privacy/' + rootGetters['user/gCurrentProfile'], JSON.stringify(privacy))
            .then(response => {
              if (response.data.status) {
                commit('mPrivacy', response.data.data);
                resolve(true);
              }
            })
            .catch(error => {
              reject(error);
            })
        });
      }
    }
  },
  mutations: {
    mPersonal(state, details) {
      state.patient = details;
    },
    SetHealthDetails(state, details) {
      state.editPatient = details;
    },
    mLanguages(state, language) {
      state.languages = language;
    },
    mReligion(state, religion) {
      state.religion = religion;
    },
    mPrivacy(state, privacy) {
      state.privacy = Object.assign(state.privacy, privacy)
    },
    mAddress(state, address) {
      state.editAddress = address
    },
    SetName(state, name) {
      state.editName = name
    },
    mUpdatePerson(state, person) {

      state.person = person
    },
  }
}